const DEFAULT_BOTTOM = '20px';

const cssVars = {
  bottom: '--floating-button-bottom-offset',
};

const selectors = {
  caContainer: 'ca-consent-root',
  floatingButton: '.ca-banner-floater-wrap',
};

export { DEFAULT_BOTTOM, cssVars, selectors };
